var Vendd = (function (Vendd) {
    "use strict";
    Vendd.LoginOrder = (function (LoginOrder) {

        var model;

        Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.ValidateLoginOrder, Vendd.LoginOrder, function (envelope) {

            var endpoints = {
                byOrderInfo: "api/LoginOrder/ValidateLoginOrder"
            };

            var options = {
                url: endpoints.byOrderInfo,
                data: envelope.message.data,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {

                if (response.success) {

                    model = response.data;

                    Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.ValidateLoginOrderSuccess(model));
                } else {
                    response.validation = true;
                    Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.ValidateLoginOrderFailure(response));
                }
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.ValidateLoginOrderError(response));
            }


            Vendd.Service.call(options);
        });

        Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.GetShipmentStatus, Vendd.LoginOrder, function (envelope) {

            var options = {
                method: "GET",
                url: "api/LoginOrder/GetShipmentTrackingData?orderCode=" + envelope.message.data.OrderCode + "&voucherCode=" + envelope.message.data.VoucherCode,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {

                if (response.success) {

                    model = response.data;

                    model.OrderCode = envelope.message.data.OrderCode;

                    Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.GetShipmentStatusSuccess(model));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.GetShipmentStatusFailure(response));
                }
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.GetShipmentStatusError(response));
            }


            Vendd.Service.call(options);
        });

        return LoginOrder;
    })(Vendd.LoginOrder || {});

    return Vendd;
})(Vendd || {});
